import Typography, { TypographyVariant } from '@hid-galaxy-ui/galaxy-react/components/Typography';
import React, { useEffect, useState } from 'react';
import IconWithLabel from '../IconWithLabel/IconWithLabel';
import { getTranslation } from '../../utils/functions';
import styles from './PasswordGuideline.module.scss';
import { useTranslation } from 'react-i18next';

interface IPasswordGuideline {
  password: string;
  setValidated: (isValidated: boolean) => void;
}
interface IPasswordCriteria {
  message: string;
  isError: boolean;
  check: (text: string) => boolean;
}

export default function PasswordGuideline(props: IPasswordGuideline) {
  const { password, setValidated } = props;
  const { t } = useTranslation();
  const checkLength = (text) => {
    if (text?.length >= 8) {
      return true;
    }
    return false;
  };
  const checkCase = (text) => {
    const caseCheckRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])');
    return caseCheckRegex.test(text);
  };
  const checkNum = (text) => {
    const numCheckRegex = new RegExp('^(?=.*\\d)');
    return numCheckRegex.test(text);
  };
  const checkSpl = (text) => {
    const specialCharCheckRegex = new RegExp('^(?=.*[-+_!@#$%^&*.,?])');
    return specialCharCheckRegex.test(text);
  };

  const msg1 = t('MINIMUM_CHARACTERS');
  const msg2 = t('UPPER_CASE_AND_LOWER_CASE');
  const msg3 = t('MINIMUM_ONE_NUMBER');
  const msg4 = t('MINIMUM_ONE_SPECIAL_CHARECTER');

  const [passwordCriteria, setPasswordCriteria] = useState<Array<IPasswordCriteria>>([
    {
      message: msg1,
      isError: true,
      check: checkLength,
    },
    {
      message: msg2,
      isError: true,
      check: checkCase,
    },
    {
      message: msg3,
      isError: true,
      check: checkNum,
    },
    {
      message: msg4,
      isError: true,
      check: checkSpl,
    },
  ]);

  useEffect(() => {
    const tempPasswordCriteria: Array<IPasswordCriteria> = passwordCriteria.map((criteria) => {
      criteria.isError = !criteria.check(password);
      return criteria;
    });
    const isError = tempPasswordCriteria.some((criteria: any) => criteria.isError);
    setPasswordCriteria([...tempPasswordCriteria]);
    setValidated(!isError);
  }, [password]);

  return (
    <>
      <Typography variant={TypographyVariant.H3} className="hid-layout__mt-04">
        {getTranslation('PASSWORD_GUIDELINE')}
      </Typography>
      <ul className={styles.passwordGuideline}>
        {/* {passwordCriteria.map((criteria, key) => (
          <li className="hid-password-guidelines__list" key={key}>
            <IconWithLabel label={criteria.message} isError={criteria.isError} />
          </li> */}
        <li className="hid-password-guidelines__list" >
            <IconWithLabel label={msg1} isError={passwordCriteria[0].isError} />
          </li>
          <li className="hid-password-guidelines__list" >
            <IconWithLabel label={msg2} isError={passwordCriteria[1].isError} />
          </li>
          
            <li className="hid-password-guidelines__list" >
            <IconWithLabel label={msg3} isError={passwordCriteria[2].isError} />
          </li>
          <li className="hid-password-guidelines__list" >
            <IconWithLabel label={msg4} isError={passwordCriteria[3].isError} />
          </li>
          {/* ))} */}
        </ul>
    </>
  );
}
